<template>
  <span class="text-base font-medium opacity-50">
    <slot />
  </span>
</template>
